// $(window).on('load', function () {
//   $('.product-items.swiper').each((idx, item) => {
//     const { swiper } = item;
//     // console.log('#######swiper', item.swiper.params);
//     swiper.params.spaceBetween = 16;
//     swiper.update();
//   })
// })

if ($(".product-items.swiper").length) {
  let interval = setInterval(function () {
    if ($(".product-items.swiper")[0].swiper) {
      clearInterval(interval);

      $(".product-items.swiper").each((idx, item) => {
        const { swiper } = item;

        console.log();
        // swiper.params.spaceBetween = 16;
        // swiper.params.breakpoints[1280].spaceBetween = 30
        swiper.destroy();

        // console.log(swiper);
        const newSwiper = new Swiper(item, {
          slidesPerView: "auto",
          loop: false,
          // spaceBetween: 16,
          autoHeight: true,
          mousewheel: false,
          noSwipingClass: "product-itmes-no-swipe",
          navigation: {
            nextEl: $(item).closest(".module-section").find(".swiper-button-next").get(0),
            prevEl: $(item).closest(".module-section").find(".swiper-button-prev").get(0),
          },
          breakpoints: {
            1200: {
              spaceBetween: 16,
              slidesPerView: 4,
            },
            1280: {
              spaceBetween: 30,
              slidesPerView: 4,
            },
          },
          on: {
            init(swiper) {
              swiper.slides.forEach((el) => {
                const $block = $(el).find(".card-col-img").first();
                const $slides = $block.find(".swiper-slide");

                if ($slides.length > 1) {
                  $block.addClass("product-itmes-no-swipe");

                  const $hoverBlock = $('<div class="hover-block"></div>');
                  for (let i = 0; i < $slides.length; i++) {
                    $hoverBlock.append($('<div class="hover-block__inner"></div>'));
                  }

                  $block.children().prepend($hoverBlock);
                }
                // console.log('iiiiiiiiiiiiiiiiiiiiii');
                new Swiper($block.find(".swiper")[0], {
                  slidesPerView: "auto",
                  loop: true,
                  pagination: {
                    el: $block.find(".swiper-pagination").get(0),
                  },
                  breakpoints: {
                    768: {
                      loop: false,
                      noSwipingClass: "product-itmes-no-swipe",
                    },
                  },
                });
              });
            },
          },
        });
      });
    }
  }, 50);

  $(document).on("mouseenter", ".hover-block__inner", function (e) {
    $(this).parent().next().get(0).swiper.slideTo($(this).index(), 0);
  });

  $(document).on("mouseleave", ".hover-block__inner", function (e) {
    if ($(e.relatedTarget).closest(".card-btns").length) return;

    $(this).parent().next().get(0).swiper.slideTo(0, 0);
  });
}
